import Banner from 'apps/main/deprecated/components/Banner'
import { useState } from 'react'

export const FrontendRoadmapBanner = () => {
  const [visible, setVisible] = useState(true)

  if (!visible) return null
  return (
    <Banner
      type="frontend-roadmap-2023"
      to="/paths/career/javascript-frontend-developer"
      onClose={() => setVisible(false)}
      description="🌞 2023년 기준 프론트엔드 개발자에게 꼭 필요한 내용만 담은 로드맵 🗺️"
      linkLabel="코드잇 컨텐츠 보러가기"
    />
  )
}
